import { IRowNode } from 'ag-grid-community';
import { OrganizationRow } from 'components/tables/data/organization/types';
import OrganizationActions from 'components/tables/data/organization/OrganizationActions';

/**
 * Column for the actions.
 */
export default function ActionsColumn({ node, data }: { node: IRowNode<OrganizationRow>; data: OrganizationRow }) {
  return (
    <OrganizationActions
      {...data}
      canDiscard={data.canDiscard}
      compactOnTablet
      onStatusChange={(status) => node.setData({ ...data, status })}
    />
  );
}
